module.exports = __webpack_public_path__ + "static/c1-72f8a422568243f2c1d032be1b600733.png";